<template>
    <div>about page</div>
</template>

<script>
    module.exports = {

    };
</script>


/** WEBPACK FOOTER **
 ** about.vue?1f7df3eb
 **/